module.exports = __webpack_public_path__ + "img/5_30.800c6f46.png";